// @ts-nocheck
import { Box, Typography, Button, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          minHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          px: 2,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: "4rem", sm: "6rem", md: "8rem" },
            fontWeight: "bold",
            color: "primary.main",
          }}
        >
          404
        </Typography>

        <Typography
          variant="h5"
          sx={{
            mb: 2,
            fontSize: { xs: "1.2rem", sm: "1.5rem" },
          }}
        >
          Oops! Page not found
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mb: 4,
            color: "gray",
            maxWidth: "500px",
          }}
        >
          The page you are looking for might have been removed, had its name
          changed, or is temporarily unavailable.
        </Typography>

        <Button
          variant="contained"
          size="large"
          onClick={() => navigate("/")}
          sx={{
            px: 4,
            py: 1.5,
            borderRadius: "30px",
            fontWeight: "600",
          }}
        >
          Go to Homepage
        </Button>
      </Box>
    </Container>
  );
};

export default NotFound;